(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-royal-touch-lux"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-set-builder]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-set-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-set-panel]'));
      var status = root.querySelector('[data-set-status]');
      var product = root.closest('[data-product]');
      var idInput = product && product.querySelector('[data-variant-id]');
      var completeItems = product ? Array.prototype.slice.call(product.querySelectorAll('[data-complete-list] [data-variant]')) : [];
      var activeTab = 'single';
      function markSelection() {
        var ids = {};
        if (activeTab === 'single') { if (idInput) ids[idInput.value] = true; }
        else {
          var btn = root.querySelector('[data-set-panel="' + activeTab + '"] [data-rtl-set-add]');
          if (btn) { try { JSON.parse(btn.getAttribute('data-rtl-set-add')).forEach(function (it) { ids[it.id] = true; }); } catch (e) {} }
        }
        completeItems.forEach(function (li) { li.classList.toggle('is-in-selection', !!ids[li.getAttribute('data-variant')]); });
      }
      function select(name) {
        activeTab = name;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-set-tab') === name;
          t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-set-panel') !== name; });
        markSelection();
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { if (!t.hasAttribute('disabled')) select(t.getAttribute('data-set-tab')); });
      });
      // Variantwissel (Los) → herbereken markering
      if (product) product.addEventListener('change', function () { window.requestAnimationFrame(markSelection); });
      markSelection();

      // Multi-item set-add → bestaande OaseCart-controller (drawer + serialisatie). Dubbelklik geblokkeerd.
      root.querySelectorAll('[data-rtl-set-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-busy') === 'true') return;
          if (!window.OaseCart) return;
          var items; try { items = JSON.parse(btn.getAttribute('data-rtl-set-add')); } catch (e) { return; }
          if (!items || !items.length) return;
          btn.setAttribute('aria-busy', 'true');
          if (status) status.textContent = 'Set wordt toegevoegd…';
          window.OaseCart.add(items).then(function () {
            btn.removeAttribute('aria-busy');
            if (status) status.textContent = 'Set toegevoegd. Het voordeel is zichtbaar in je winkelwagen.';
          }).catch(function () {
            btn.removeAttribute('aria-busy');
            if (status) status.textContent = 'Er ging iets mis. Probeer het opnieuw.';
          });
        });
      });

      // Contextuele quick-add van losse maten
      root.parentNode && root.closest('[data-product]').querySelectorAll('[data-cart-add-one]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || !window.OaseCart) return;
          btn.disabled = true;
          window.OaseCart.add([{ id: parseInt(btn.getAttribute('data-cart-add-one'), 10), quantity: 1 }])
            .then(function () { btn.disabled = false; }).catch(function () { btn.disabled = false; });
        });
      });
    });

    // Smooth scroll naar set-builder (respecteert reduced-motion via CSS scroll-behavior)
    document.querySelectorAll('[data-scroll-to]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var el = document.getElementById(a.getAttribute('data-scroll-to'));
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ugc-reel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reels = document.querySelectorAll('[data-ugc-reel]');
    if (!reels.length) return;
    var product = document.querySelector('[data-product]');
    reels.forEach(function (reel) {
      var groups = Array.prototype.slice.call(reel.querySelectorAll('[data-ugc-variant]'));
      var headingEl = reel.querySelector('[data-ugc-heading]');
      var show = function (vid) {
        vid = String(vid);
        var any = false;
        groups.forEach(function (g) {
          var match = g.getAttribute('data-ugc-variant') === vid;
          g.hidden = !match;
          if (match) {
            any = true;
            if (headingEl) {
              var h = g.getAttribute('data-ugc-heading-text');
              if (h) headingEl.textContent = h;
            }
          }
        });
        reel.hidden = !any;
      };
      if (!product) return;
      var idInput = product.querySelector('[data-variant-id]');
      if (!idInput) return;
      // Ververs bij variantwissel (haakt op de bestaande PDP-variantlogica die [data-variant-id] bijwerkt)
      product.addEventListener('change', function () {
        window.requestAnimationFrame(function () { show(idInput.value); });
      });
      // Init (dekt o.a. ?variant= deep-links)
      if (idInput.value) show(idInput.value);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
